// Presentazione (unica fonte) del modulo di scorrimento K_ser: il calcolo lo
// produce in N/mm (EN 1995-1-1 §7.1), ma all'utente si mostra in kN/mm.
export const K_SER_UNIT = "kN/mm";

const K_SER_DECIMALS = 2;

// formatKSer converte K_ser da N/mm (valore calcolato) a kN/mm per la vista;
// null quando il valore non c'e'.
export const formatKSer = (nPerMm: number | null | undefined): { value: string; unit: string } | null =>
  nPerMm == null ? null : { value: (nPerMm / 1000).toFixed(K_SER_DECIMALS), unit: K_SER_UNIT };

// kSerLabel e' "12.34 kN/mm" oppure "—": usata da celle e indice di ricerca.
export const kSerLabel = (nPerMm: number | null | undefined): string => {
  const formatted = formatKSer(nPerMm);
  return formatted ? `${formatted.value} ${formatted.unit}` : "—";
};
